import React, { useEffect, useState } from 'react';
import { ToastContainer, Toast } from '@bnvsrnd/brand-assets';
import { subscribeToasts } from '../../utils/toastBus';

/**
 * 전역 DS 토스트 호스트 — 앱 루트에 1개만 마운트.
 * toastBus 의 toast.* 호출을 구독해 우측 상단에 DS Toast 로 표시한다.
 * Toast 는 duration 으로 자동 닫히며, onClose 에서 상태에서 제거한다.
 */
function DSToastHost() {
    const [toasts, setToasts] = useState([]);

    useEffect(() => subscribeToasts((entry) => {
        setToasts((prev) => [...prev, entry]);
    }), []);

    const remove = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

    return (
        <ToastContainer position="top-right">
            {toasts.map((t) => (
                <Toast
                    key={t.id}
                    type={t.type}
                    duration={3000}
                    onClose={() => remove(t.id)}
                >
                    {t.message}
                </Toast>
            ))}
        </ToastContainer>
    );
}

export default DSToastHost;
